module.exports = __webpack_public_path__ + "img/856.67fed1f1.png";